<template>
  <div class="pageContent shoppingCard">
    <LoadingModal bgcolor="transparent" />
    <div>
      <Top :title="name" :message="tips" />
      <TypeLists :list="arryImg" @selItem="imgClick" />
      <VTitle val="请选择面值" :showLine="false" />
      <ProductDenoList
        :list="arryList"
        @selItem="handleSelList"
        :isMember="isMember"
        :active="activeicon2"
        :vip_discount="vip_discount"
      />
      <VTitle val="支付方式" :showLine="false" />
      <PayWay
        v-if="balance > 0 || couponsBalanceList.length > 0"
        :sellData="sellData"
        :tips="tips"
        :discount="discount"
        :isWechatPay="wechatpay"
        :type="8"
        :params="params"
        :balance="balance"
        :isMember="isMember"
        :vip_discount="vip_discount"
        :couponsBalanceList="couponsBalanceList"
        :couponsDeduct="couponsDeduct"
        @onComfirm="payHandle"
      />
      <Tips>
        <div slot="content">
          <ul
            v-if="categoryName === 'starCharge'"
            style="
              list-style: disc;
              color: #000;
              opacity: 0.53;
              margin-left: 15px;
            "
          >
            <li style="list-style: disc">
              <b>如何使用：</b>
              <p>
                1、手机下载星星充电app，打开app,进入首页，点击“扫码充电—输入券码—确认兑换”进行绑定，在app中心页点击[卡券]可查看到账卡券。
              </p>
              <p>2、券绑定后，有效期为一年，请及时使用。</p>
            </li>
          </ul>
        </div>
      </Tips>
    </div>
  </div>
</template>

<script>
import PayWay from "components/PayWay";
import TypeLists from "./ProductTypeList";
import ProductDenoList from "./ProductDenoList";
import { getProductList } from "api/onLine";
import iconList from "server/data/icon.json";
import { buyShoppingCard } from "api/onLine";

export default {
  props: {
    name: String,
    cid: Number,
    type: String,
    balance: Number,
    couponsDeduct: Number,
    isMember: Boolean,
    mouldId: String,
    couponsBalanceList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    TypeLists,
    PayWay,
    ProductDenoList,
  },
  data() {
    return {
      arryImg: [],
      arryList: [],
      activeicon1: "0",
      activeicon2: -1,
      sellData: { sell_price: -1 },
      serviceId: null,
      tips: "",
      describe: "",
      discount: 0,
      index: 0,
      wechatpay: false,
      params: {},
      vip_discount: 0,
      categoryName: "",
    };
  },
  created() {
    this.$store.commit("setPageLoading", true);
    this.arryImg = iconList.carCharging;
  },
  mounted() {
    this.categoryName = this.arryImg[0].id;
    this.loadList(this.categoryName);
  },
  methods: {
    handleSelList(i) {
      this.activeicon2 = i;
      this.sellData = {
        ...this.arryList[i],
        sell_price: Number(this.arryList[i].productCustomerPrice),
      };
      this.params.productId = this.arryList[i].productId;
      this.params.mouldId = this.mouldId;
    },
    imgClick(index) {
      this.sellData.sell_price = -1;
      this.activeicon2 = -1;
      this.categoryName = this.arryImg[index].id;
      if (this.activeicon1 !== index) {
        this.activeicon1 = index;
        this.loadList(this.categoryName);
      }
    },
    loadList(ident) {
      getProductList(ident, this.mouldId).then((res) => {
        if (res.status == 200) {
          this.arryList = res.data;
        } else {
          this.arryList = [];
          this.$error(res.message);
        }
        this.$nextTick(() => {
          this.$store.commit("setPageLoading", false);
        });
      });
    },
    payHandle(data) {
      this.$loading("订单处理中，请稍后...");
      buyShoppingCard(data).then((res) => {
        if (res.status == 200) {
          setTimeout(() => {
            this.$successSync("下单成功", () => {
              this.$push({
                path: "/orders",
                query: { type: "-1" },
              });
            });
          }, 5000);
        } else {
          this.$error(res.message);
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.shoppingCard {
  .phone {
    margin-top: 10px;
    padding: 10px;
    box-sizing: border-box;
    background: #fff;
    font-weight: 900;
    font-size: 20px;
    color: var(--redColor);
  }
  /deep/ .van-field__control {
    color: #ff3300;
    font-size: 20px;
    font-weight: 900;
  }
}
</style>
